module.exports = __webpack_public_path__ + "img/menu-wulainwang.cae91fea.svg";